import React from 'react';
import { Link } from 'react-router-dom';
import ResetPasswordForm from './ResetPasswordForm';
import HomeDecorator from './HomeDecorator';
import { ROUTE_LOGIN } from '../../constants/pathnames';
import { Button } from 'new/elements/Button';

class ResetPasswordView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      gRecaptchaResponse: null,
    };

    this._handleInputChanged = this._handleInputChanged.bind(this);
    this._handleFormSubmit = this._handleFormSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.resetPasswordFormLoaded) {
      this.props.resetPasswordFormLoaded();
    }
  }

  render() {
    const { email, gRecaptchaResponse } = this.state;
    const { emailSent, error, isLoading } = this.props;

    return HomeDecorator(
      emailSent ? (
        <div style={{ width: '100%' }}>
          <h2>Password reset sent!</h2>
          <p>Please check your email for a password reset link.</p>
          <Button variant="contained" color="primary" style={{ width: '100%' }}>
            <Link style={{ color: 'white', textDecoration: 'none' }} to={ROUTE_LOGIN}>
              Back to Sign In
            </Link>
          </Button>
        </div>
      ) : (
        <ResetPasswordForm
          email={email}
          gRecaptchaResponse={gRecaptchaResponse}
          onSubmit={this._handleFormSubmit}
          onInputChanged={this._handleInputChanged}
        />
      ),
      error,
      isLoading,
    );
  }

  _handleInputChanged(type, value) {
    this.setState({
      [type]: value,
    });
  }

  _handleFormSubmit(event) {
    event.stopPropagation();
    event.preventDefault();

    this.props.resetPassword(this.state.email, this.state.gRecaptchaResponse);
  }
}

export default ResetPasswordView;
